import React from 'react'
import ReactDataGrid from 'react-data-grid'

class Grid extends React.Component {
    constructor(props) {
        super(props);

        const index = this._findIndex(props.value);
        let selectedIndexes = [];

        if (index)
            selectedIndexes = [index];

        this.state = {
            value: props.value,
            selectedIndexes: selectedIndexes
        }
    }

    setValue = (value) => {
        this._select(value);
    }

    getValue = () => {
        return this.state.value;
    }

    clear = () => {
        this._handleChange(null);
    }

    focus = () => { return; }
    select = () => { return; }
    flag = () => { return; }
    validate = () => { return null; }

    completed = () => {
        return !((this.state.value === "" || this.state.value === null) && this.props.required)
    }

    // Events
    onChange = (value) => {
        this.props.onChange && this.props.onChange(value);
    }

    // Private
    _select = (value) => {
        const index = this._findIndex(value);

        if (index)
            this.setState({
                value,
                selectedIndexes: [index]
            });
    }

    _unSelect = () => {
        this.setState({ selectedIndexes: [] });
    }

    _getSelectedIndexes = () => {
        return this.state.selectedIndexes;
    }

    _rowGetter = (i) => {
        if (!this.props.items)
            return {};

        return this.props.items[i];
    }

    _findIndex = (key) => {
        if (!this.props.items)
            return null;

        const rowKey = this.props.rowKey;

        return this.props.items.findIndex(function (e) {
            return (e[rowKey] === key);
        });
    }

    _handleRowClick = (rowIdx, row) => {
        if (rowIdx < 0)
            return;

        const value = this.props.items[rowIdx][this.props.rowKey];
        this.setState({
            value: value,
            selectedIndexes: [rowIdx]
        });

        this._update(value);
    }

    _handleSort = (sortColumn, sortDirection) => {
        this.props.onSort(sortColumn, sortDirection);
    }

    _update = (value) => {
        const me = this;

        this.setState({ value }, function () {
            const validationResult = this.validate();
            const requiredPassed = this.completed();
            const validationPassed = (validationResult === null || validationResult === undefined);
            const status = requiredPassed && validationPassed;

            // Show error status if neccesary
            this.flag(status);

            // If managed by forms, trigger field change, then change
            if (this.props.managed)
                this.props.onFieldChange(value, this.props.name, function () { me.onChange(value); });
            else
                // If not, only trigger this comp change
                this.onChange(value);
        });
    }

    // React
    componentWillReceiveProps(nextProps, nextState) {
        // Columns changed?
        if (nextProps.columns !== this.props.columns)
            this.setState({
                columns: nextProps.columns
            });

        // Value changed?
        if (nextProps.value !== this.props.value) {
            const index = this._findIndex(nextProps.value);

            if (index)
                this.setState({
                    value: nextProps.value,
                    selectedIndexes: [index]
                });
        }
    }

    // React
    render() {
        let className = "react-grid-stripped";
        let items = this.props.items || [];

        if (this.props === null)
            return (<div>Loading...</div>);

        if (this.props.disabled)
            className = "react-grid-disabled";

        return (
            <div className={className}>
                <ReactDataGrid
                    rowKey={this.props.rowKey}
                    columns={this.props.columns}
                    rowGetter={this._rowGetter}
                    rowsCount={items.length}
                    minHeight={this.props.height}
                    onRowClick={!this.props.disabled && this._handleRowClick}
                    onGridSort={this._handleSort}
                    rowSelection={!this.props.disabled && {
                        showCheckbox: false,
                        enableShiftSelect: false,
                        selectBy: { indexes: this.state.selectedIndexes }
                    }} />
            </div>
        );
    }
}

// Mark this as a form component
Grid.defaultProps = {
    formControl: true,
    managed: false,
    disabled: false,
    height: 500
};

export default Grid;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/grid/Grid.js